import React, { type FC } from 'react';

export const EmptySearchIconLarge: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="128"
    height="121"
    viewBox="0 0 128 121"
  >
    <title>Empty search icon</title>
    <defs>
      <path
        id="a"
        d="M0 0.38516965L127.544 0.38516965 127.544 104.031405 0 104.031405z"
      />
      <path
        id="c"
        d="M0.411359385 0.528L5.26323441 0.528 5.26323441 9.73807317 0.411359385 9.73807317z"
      />
    </defs>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="none"
      strokeWidth="1"
      transform="translate(-762 -367) translate(762 366)"
    >
      <g transform="translate(0 9.472)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          fill="#EAF0FA"
          d="M125.952 25.15c-6.686-4.4-17.46-6.252-30.366-5.478C83.61 3.27 62.287-4.058 43.587 3.162c-18.7 7.222-28.78 26.675-25.57 46.46C8.151 57.64 1.721 66.137.078 73.753c-.636 2.95 2.736 5.327 5.09 3.568 5.2-3.884 11.414-7.884 18.444-11.856.182-.102.374-.204.557-.307 3.657 19.527 13.737 35.548 32.07 38.41 19.404 3.03 37.285-8.931 43.111-30.802l5.101-3.555c2.036-1.418 2.905-3.922 2.162-6.228-1.834-5.69-5.175-16.177-6.427-20.895l-.147.255a42.667 42.667 0 00-2.073-6.323 242.89 242.89 0 015.03-1.205c7.937-1.81 15.31-3.054 21.863-3.708 2.968-.297 3.682-4.251 1.093-5.955"
          mask="url(#b)"
        />
      </g>
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeWidth="2"
        d="M43.516 12.377c-2.532 2.559-5.038 12.17-2.354 21.185M42.866 11.615c8.641-.044 23.172 8.607 27.435 19.625"
      />
      <g transform="translate(43 .472)">
        <mask id="d" fill="#fff">
          <use xlinkHref="#c" />
        </mask>
        <path
          fill="#EAF0FA"
          d="M1.691 9.645C-.347 10.818-.09.528 3.473.528c3.565 0 1.19 7.408-1.782 9.117"
          mask="url(#d)"
        />
      </g>
      <path
        fill="#EAF0FA"
        d="M41.709 10.677c2.16-.26-1.195-5.848-4.35-4.255-3.154 1.592 1.202 4.635 4.35 4.255"
      />
      <path
        fill="#031D44"
        d="M89.426 65.262a2.115 2.115 0 11-4.23 0 2.115 2.115 0 014.23 0"
      />
      <path
        stroke="#031D44"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M51.954 118.09a56.621 56.621 0 006.298 2.235 3.637 3.637 0 002.039-6.98l3.76 1.098a3.636 3.636 0 002.038-6.981l4.296 1.255a3.636 3.636 0 002.04-6.981L53.36 96.168l10.568-3.771"
      />
      <path
        stroke="#031D44"
        strokeLinecap="round"
        strokeWidth="2"
        d="M113.04 65.262c0 14.21-11.52 25.73-25.73 25.73-14.209 0-25.729-11.52-25.729-25.73 0-14.209 11.52-25.729 25.73-25.729 14.208 0 25.728 11.52 25.728 25.73z"
      />
      <path
        stroke="#031D44"
        strokeLinecap="round"
        strokeWidth="2"
        d="M68.943 100.181L75.013 88.538"
      />
      <path
        stroke="#FFF"
        strokeLinecap="round"
        strokeWidth="2"
        d="M84.556 96.967c-1.377 2.755-3.673 4.133-3.673 4.133"
      />
    </g>
  </svg>
);
